import { vlanConfigValue, vlanConfigLabel, ETHER_TYPE_LABEL } from './model';
import { AGENT_MODEL } from '@nrwl/common-lib';
export const TwampReflectorConfigMapping = {
  ALIAS: 'alias',
  CUSTOMER: 'customer',
  TECHINICIAN: 'technician',
  TEST_TYPE: 'testType',
  RUN_TYPE: 'runType',
  AGENT_TYPE: 'agentType',
  SELECTED_ORIGINATOR: 'selectedOriginator',
  REFLECTOR_MODE: 'mode',
  IP_VERSION: 'ipVersion',
  ADDRESS: 'source-ip',
  SUBNET: 'subnet',
  GATEWAY: 'gateway',
  CONTROL_PORT: 'port',
  UDP_PORT: 'reflector-udp-port',
  SESSIONS: 'sessions',
  FLOWS: 'flows',
  ADDRESS_IPV6: 'ipAddressV6',
  PREFIX_V6: 'prefixV6',
  GATEWAY_V6: 'gatewayV6',
  VLAN_CONFIG: 'vlanConfig',
  ETHER_TYPE: 'ether-type',
  VLAN_ENABLED: 'vlanEnabled',
  SVLAN_ID: 'vlan-id',
  CVLAN_ID: 'inner-vlan-id',
  REBOOT: 'reboot'
};

export const TWAMP_REFLECTOR_MODEL_CONFIG = {
  id: 'twamp_reflector_test',
  agentConfig: {
    default: {
      setup: {
        alias: {
          enabled: true,
          value: 'Twamp-Reflector',
          outputField: TwampReflectorConfigMapping.ALIAS,
          tabId: 'twamp_reflector_setup',
          restoreOnAgentChange: true
        },
        customer: {
          enabled: true,
          value: '',
          outputField: TwampReflectorConfigMapping.CUSTOMER,
          tabId: 'twamp_reflector_setup',
          outputOptional: true,
          restoreOnAgentChange: true
        },
        technician: {
          enabled: true,
          value: '',
          outputField: TwampReflectorConfigMapping.TECHINICIAN,
          tabId: 'twamp_reflector_setup',
          outputOptional: true,
          restoreOnAgentChange: true
        },
        runType: {
          enabled: true,
          value: 'on-going',
          outputField: TwampReflectorConfigMapping.RUN_TYPE,
          tabId: 'twamp_reflector_setup'
        },
        agentType: {
          enabled: true,
          value: 'default',
          outputField: TwampReflectorConfigMapping.AGENT_TYPE,
          restoreOnAgentChange: true,
          tabId: 'twamp_reflector_setup'
        },
        selectedOriginator: {
          enabled: true,
          value: null,
          outputField: TwampReflectorConfigMapping.SELECTED_ORIGINATOR,
          restoreOnAgentChange: true,
          tabId: 'twamp_reflector_setup'
        },
        reflectorMode: {
          enabled: true,
          value: 'light',
          outputField: TwampReflectorConfigMapping.REFLECTOR_MODE,
          tabId: 'twamp_reflector_setup'
        },
        ipVersion: {
          enabled: true,
          value: 'v4',
          outputField: TwampReflectorConfigMapping.IP_VERSION,
          lookup: ["capabilities.phy['default-test-ip']"],
          tabId: 'twamp_reflector_setup'
        },
        address: {
          enabled: true,
          value: '192.168.2.10',
          outputField: TwampReflectorConfigMapping.ADDRESS,
          tabId: 'twamp_reflector_setup',
          outputOptional: true
        },
        subnet: {
          enabled: true,
          value: '255.255.255.0',
          outputField: TwampReflectorConfigMapping.SUBNET,
          tabId: 'twamp_reflector_setup',
          outputOptional: true
        },
        gateway: {
          enabled: true,
          value: '192.168.2.1',
          outputField: TwampReflectorConfigMapping.GATEWAY,
          tabId: 'twamp_reflector_setup',
          outputOptional: true
        },
        udpPort: {
          enabled: true,
          value: 50000,
          outputField: TwampReflectorConfigMapping.UDP_PORT,
          tabId: 'twamp_reflector_setup',
          outputOptional: true
        },
        controlPort: {
          enabled: true,
          value: 862,
          outputField: TwampReflectorConfigMapping.CONTROL_PORT,
          tabId: 'twamp_reflector_setup',
          outputOptional: true
        },
        flows: {
          enabled: true,
          value: 50,
          outputField: TwampReflectorConfigMapping.FLOWS,
          tabId: 'twamp_reflector_setup',
          outputOptional: true
        },
        sessions: {
          enabled: true,
          value: 5,
          outputField: TwampReflectorConfigMapping.SESSIONS,
          tabId: 'twamp_reflector_setup',
          outputOptional: true
        },
        ipAddressV6: {
          enabled: true,
          value: 'fc00::10',
          outputField: TwampReflectorConfigMapping.ADDRESS_IPV6,
          tabId: 'twamp_reflector_setup',
          outputOptional: true
        },
        prefixV6: {
          enabled: true,
          value: '64',
          outputField: TwampReflectorConfigMapping.PREFIX_V6,
          tabId: 'twamp_reflector_setup',
          outputOptional: true
        },
        gatewayV6: {
          enabled: true,
          value: 'fc00::1',
          outputField: TwampReflectorConfigMapping.GATEWAY_V6,
          tabId: 'twamp_reflector_setup',
          outputOptional: true
        },
        vlanConfig: {
          enabled: true,
          value: vlanConfigValue.UNTAGGED,
          options: {
            type: 'dropdown',
            value: [
              { name: vlanConfigLabel.UNTAGGED, value: vlanConfigValue.UNTAGGED },
              { name: vlanConfigLabel.SINGLE_VLAN, value: vlanConfigValue.SINGLE_VLAN }
            ]
          },
          outputField: TwampReflectorConfigMapping.VLAN_CONFIG,
          tabId: 'twamp_reflector_setup'
        },
        vlanId: {
          enabled: true,
          value: null,
          outputField: TwampReflectorConfigMapping.SVLAN_ID,
          tabId: 'twamp_reflector_setup',
          outputOptional: true
        },
        cvlanId: {
          enabled: true,
          value: null,
          outputField: TwampReflectorConfigMapping.CVLAN_ID,
          tabId: 'twamp_reflector_setup',
          outputOptional: true
        },
        ethertype: {
          enabled: true,
          value: ETHER_TYPE_LABEL.ETHER_8100,
          outputField: TwampReflectorConfigMapping.ETHER_TYPE,
          tabId: 'twamp_reflector_setup',
          outputOptional: true
        },
        reboot: {
          enabled: true,
          value: false,
          outputField: TwampReflectorConfigMapping.REBOOT,
          tabId: 'twamp_reflector_setup',
          outputOptional: true
        }
      },

      running: {
        add: 'anything that is different between agents in running view'
      },

      final: {
        add: 'anything that is different between agents in final report'
      }
    },
    [AGENT_MODEL.VPMA]: {
      setup: {
        vlanConfig: {
          enabled: true,
          value: vlanConfigValue.UNTAGGED,
          outputField: TwampReflectorConfigMapping.VLAN_CONFIG,
          options: {
            type: 'dropdown',
            value: [
              { name: vlanConfigLabel.UNTAGGED, value: vlanConfigValue.UNTAGGED },
              { name: vlanConfigLabel.SINGLE_VLAN, value: vlanConfigValue.SINGLE_VLAN },
              { name: vlanConfigLabel.Q_IN_Q, value: vlanConfigValue.Q_IN_Q }
            ]
          },
          tabId: 'twamp_reflector_setup'
        }
      }
    },
    [AGENT_MODEL.VPMA_L]: {
      setup: {
        vlanConfig: {
          enabled: true,
          value: vlanConfigValue.UNTAGGED,
          outputField: TwampReflectorConfigMapping.VLAN_CONFIG,
          options: {
            type: 'dropdown',
            value: [
              { name: vlanConfigLabel.UNTAGGED, value: vlanConfigValue.UNTAGGED },
              { name: vlanConfigLabel.SINGLE_VLAN, value: vlanConfigValue.SINGLE_VLAN },
              { name: vlanConfigLabel.Q_IN_Q, value: vlanConfigValue.Q_IN_Q }
            ]
          },
          tabId: 'twamp_reflector_setup'
        }
      }
    },
    [AGENT_MODEL.VQT]: {
      setup: {
        vlanConfig: {
          enabled: true,
          value: vlanConfigValue.UNTAGGED,
          outputField: TwampReflectorConfigMapping.VLAN_CONFIG,
          options: {
            type: 'dropdown',
            value: [
              { name: vlanConfigLabel.UNTAGGED, value: vlanConfigValue.UNTAGGED },
              { name: vlanConfigLabel.SINGLE_VLAN, value: vlanConfigValue.SINGLE_VLAN },
              { name: vlanConfigLabel.Q_IN_Q, value: vlanConfigValue.Q_IN_Q }
            ]
          },
          tabId: 'twamp_reflector_setup'
        }
      }
    }
  }
};
